<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation2
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        :todo-list.sync="todoList"
        show-to-do
        @reloadData="requestData()"
        @todoCheck="todoCheckFun"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px; padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.schemeNo"
              placeholder="请输入方案编号"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <date-select :search-date.sync="masterList.tableQuery.searchDate" />
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table2
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="addFun()"
        @edit="editFun(arguments)"
        @del="delFun(arguments)"
        @view="viewFun(arguments)"
        @dblclick="viewFun(arguments)"
        @exportDoc="exportDocFun(arguments)"
        @export="batchExport(masterList)"
      />
    </div>

    <!-- 查看-->
    <view-dialog
      :data-id="id"
      :event-type="'view'"
      :dialog-title="dialogAddEditTitle"
      :dialog-visible.sync="dialogAddEditVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />

    <!-- 待办列表 -->
    <task-list-dialog
      :dialog-visible.sync="dialogTaskVisible"
      dialog-title="待处理的活动质量问题"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation2 from '@/components/TableOperation2'
// 列表设置tableKeyMixin
import tableOperationMixin2 from '@/mixin/tableOperationMixin2'
// 导出 batchExportMixin
import batchExportMixin2 from '@/mixin/batchExportMixin2'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin2 from '@/mixin/tableCustomMixin2'
// 日期选择
import DateSelect from '@/components/DateSelect'
// 查看
import ViewDialog from './components/viewDialog'
// 待办列表
import taskListDialog from './components/taskListDialog'
// 权限验证
import checkPermission from '@/utils/permission'
// 终端恢复申请API
import { loadActivityWarningInfoListDataApi, exportActivityWarningInfoListDataApi, countTodoActivityWarningInfoListListDataApi } from '@/api/v2/activityWarningInfoList';
import { downloadSchemeActivityWarningInfoApi } from '@/api/v2/dataTemplate';

export default {
  name: 'ActivityWarningInfoListView',
  components: {
    CustomTable2,
    TableOperation2,
    DateSelect,
    ViewDialog,
    taskListDialog
  },
  mixins: [tableCustomMixin2, tableOperationMixin2, batchExportMixin2],
  data() {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'activity_warning_info_list_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['activity_warning_info_list_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['activity_warning_info_list_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          },
          {
            permissionSigns: ['activity_warning_info_list_export'],
            prop: 'exportDoc',
            label: '导出方案质量问题清单',
            method: 'exportDoc'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          schemeNo: '',
          searchDate: ''
        }
      },
      // 待办
      todoList: [
        { permissionSigns: ['activity_warning_info_list_audit'], label: '待处理的活动质量问题', method: 'todoCheck', count: 0}
      ],
      id: null,
      eventType: '',
      dialogAddEditVisible: false,
      dialogAddEditTitle: '',
      dialogTaskVisible: false
    }
  },
  created() {
    let _this = this;
    // 初始化主列表Table列
    _this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', label: '省区', filterColumn: 'ts.province_names', width: 100 },
      { prop: 'cityName', label: '城市', filterColumn: 'ts.city_names', width: 100 },
      { prop: 'schemeNo', label: '方案编号', filterColumn: 'ts.project_no', width: 200 },
      { prop: 'schemeName', label: '方案名称', filterColumn: 'ts.name', width: 200 },
      { prop: 'sellId', label: '活动编号', filterColumn: 'tawil.sell_id', width: 120 },
      { prop: 'activityName', label: '活动名称', filterColumn: 'tcs.activity_name', width: 160 },
      { prop: 'activityDate', label: '活动日期', filterColumn: 'tcs.activity_date', width: 120 },
      { prop: 'storeNames', label: '活动场所', filterColumn: 'tcs.store_names', width: 160 },
      { prop: 'userName', label: '活动人员', filterColumn: 'tu.name', width: 120 },
      { prop: 'warningTime', label: '生成时间', filterColumn: 'tawil.warning_time', width: 140 },
      { prop: 'warningInfo', label: '问题内容', filterColumn: 'tawil.warning_info', width: 180 },
      { prop: 'isAuditInfoValue', label: '是否审核生成', filterColumn: 'tawil.is_audit_info', filterValue: 'isAuditInfo', filterArray: [{ label: '是', value: 1 }, { label: '否', value: 2 }], width: 140 },
      { prop: 'auditResultValue', label: '审核结果', filterColumn: 'tawil.audit_result', filterValue: 'auditResult', filterArray: [{ label: '通过', value: 1 }, { label: '退回', value: 2 }], width: 120 },
      { prop: 'auditorName', label: '审核人', filterColumn: 'tawil.auditor_name', width: 120 },
      { prop: 'processStatusValue', label: '处理状态', filterColumn: 'tawil.process_status', filterValue: 'processStatus', filterArray: [{ label: '待处理', value: 1 }, { label: '忽略', value: 2 }, { label: '据实', value: 3 }], width: 120 },
      { prop: 'processUserName', label: '处理人', filterColumn: 'tawil.process_user_name', width: 120 },
      { prop: 'processTime', label: '处理时间', filterColumn: 'tawil.process_time', width: 140 },
      { prop: 'processInfo', label: '处理说明', filterColumn: 'tawil.process_info', width: 160 },
      { prop: 'remark', label: '备注', filterColumn: 'tawil.remark', width: 200 },
      { prop: 'operatorName', filterColumn: 'tawil.operator_name', label: '操作人', width: 120 },
      { prop: 'operationTime', filterColumn: 'tawil.operation_time', label: '操作时间', width: 150, isBetween: true }
    ]
    // 默认主列表Table列
    _this.getInitTableColumns()
    _this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData() {
      let _this = this;
      loadActivityWarningInfoListDataApi(_this.masterList.tableQuery).then((response) => {
        const { data } = response;
        _this.handleData(data.list || [])
        _this.masterList.tableDataTotal = data.total || 0
      }).catch()
      this.getTodoCount()
    },
    // 获取待办任务数量
    getTodoCount() {
      let _this = this;
      // 待处理
      if (checkPermission(['activity_warning_info_list_audit'])) {
        countTodoActivityWarningInfoListListDataApi({ processStatus: 1 }).then((response) => {
          _this.todoList[0].count = response.data || 0;
        })
      }
    },
    // 审核
    todoCheckFun() {
      this.dialogTaskVisible = !this.dialogTaskVisible
    },
    // 查看
    viewFun(args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要查看的数据行', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'view'
      _this.dialogAddEditTitle = '查看活动质量问题'
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible
    },
    // 导出质量问题清单
    exportDocFun(args){
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要操作的数据行', type: 'warning' })
        return
      }
      downloadSchemeActivityWarningInfoApi({schemeId: args[0].schemeId}).then(response => { 
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    },
    // 导出数据API
    exportByPage() {
      let _this = this;
      exportActivityWarningInfoListDataApi(_this.exportObj).then(response => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
